import {
  MinusCircleOutlined,
  PlusCircleOutlined,
  SearchOutlined,
  SyncOutlined,
  YoutubeOutlined
} from "@ant-design/icons";
import { Input, Card, Button, Select } from "antd";
import { useState } from "react";

const { Search } = Input;

const EXISTENCE_FILTER_OPTIONS = [
  { label: "All", value: "" },
  { label: "Yes", value: "true" },
  { label: "No", value: "false" }
];

const ContestFilters = ({
  searchQuery = "",
  onSearchChange = () => {},
  onUpdateAllContests = () => {},
  onUpdateAllYoutubeSolutions = () => {},
  handleOpenCreateContestModal = () => {},
  handleOpenContestExclusionManagerModal = () => {},
  isUpdatingContests = false,
  isUpdatingYoutube = false,
  userConfig = null,
  contestFilters = {},
  onContestFiltersChange = () => {}
}) => {
  const [inputValue, setInputValue] = useState(searchQuery);

  return (
    <Card style={{ marginBottom: "20px" }}>
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          alignItems: "center",
          gap: "12px"
        }}
      >
        <Search
          placeholder="Search by contest name"
          allowClear
          enterButton={<SearchOutlined />}
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          onSearch={onSearchChange}
          style={{ flex: "1 1 auto", minWidth: "min(250px, 100%)" }}
        />
        <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
          <span>YouTube Link:</span>
          <Select
            style={{ width: "min(100px, 100%)" }}
            value={contestFilters.hasYoutubeLinkFilter || ""}
            onChange={(value) => {
              onContestFiltersChange((prev) => ({
                ...prev,
                hasYoutubeLinkFilter: value
              }));
            }}
            options={EXISTENCE_FILTER_OPTIONS}
          />
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
          <span>Timestamps:</span>
          <Select
            style={{ width: "min(100px, 100%)" }}
            value={contestFilters.hasYoutubeTimestampsFilter || ""}
            onChange={(value) => {
              onContestFiltersChange((prev) => ({
                ...prev,
                hasYoutubeTimestampsFilter: value
              }));
            }}
            options={EXISTENCE_FILTER_OPTIONS}
          />
        </div>
        {userConfig?.globalContests?.hasCriticalAccess && (
          <>
            <Button
              type="primary"
              icon={<PlusCircleOutlined />}
              onClick={handleOpenCreateContestModal}
            >
              Create New Contest
            </Button>
            <Button
              type="default"
              icon={<MinusCircleOutlined />}
              onClick={handleOpenContestExclusionManagerModal}
            >
              Manage Exclusion Patterns
            </Button>
            <Button
              type="primary"
              icon={<SyncOutlined />}
              loading={isUpdatingContests}
              onClick={onUpdateAllContests}
            >
              Update All Contests
            </Button>
            <Button
              type="default"
              icon={<YoutubeOutlined />}
              loading={isUpdatingYoutube}
              onClick={onUpdateAllYoutubeSolutions}
            >
              Update YouTube Solutions
            </Button>
          </>
        )}
      </div>
    </Card>
  );
};

export default ContestFilters;
